import { create, StoreApi, UseBoundStore } from "zustand";
import { useCurrentGaiaStore } from "@/engine/viewer/core/useGaiaStoreContainer";
import { ViewerState } from "@/engine/viewer/core/useViewerStore";

export interface GaiaStoreInterface {
  gaiaLinkedViewerStore: UseBoundStore<StoreApi<ViewerState>>;
  uploadUnitVisible: boolean;
  gaiaStoreActions: {
    updateUploadUnitVisible: (uploadUnitVisible: boolean) => void;
  };
}

export const createEmptyGaiaStore = (
  gaiaLinkedViewerStore: UseBoundStore<StoreApi<ViewerState>>,
) =>
  create<GaiaStoreInterface>((set) => ({
    gaiaLinkedViewerStore: gaiaLinkedViewerStore,
    uploadUnitVisible: false,
    gaiaStoreActions: {
      updateUploadUnitVisible: (uploadUnitVisible) =>
        set(() => ({ uploadUnitVisible })),
    },
  }));

export function useGaiaStore<T = GaiaStoreInterface>(
  selector: (state: GaiaStoreInterface) => T = (state) => state as unknown as T,
) {
  const gaiaStore = useCurrentGaiaStore();

  if (!gaiaStore) throw new Error("Gaia has not been loaded.");

  return gaiaStore(selector);
}
